import React from "react";
import { Input } from "@/components/ui/input";

interface FormFieldProps {
    label: string;
    type?: string;
    placeholder?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormField: React.FC<FormFieldProps> = ({
    label,
    type = "text",
    placeholder,
    value,
    onChange,
}) => {
    return (
        <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">
                {label}
            </label>

            <Input
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="h-11"
            />
        </div>
    );
};

export default FormField;